import React from 'react';
import {MenuController} from '../components.js';

class FISelector extends React.Component {
	constructor(props) {
		super(props);

		this.onClick = this.onClick.bind(this);
	}

	onClick(e) {
		const currentSponsor = window._fiSponsor.sponsors[0].id;

		const selectedSponsor = e.currentTarget.getAttribute('data-id');

		if(currentSponsor !== selectedSponsor) {
			window._fiSponsor.selectSponsor(selectedSponsor);
		}
	}
	render() {
		window._fiSponsor.loadSessionInfo();

		var selectorContent = [];

		for(var sKey in window._fiSponsor.sponsors) {
			const sponsor = window._fiSponsor.sponsors[sKey];
			const sponsorItem = {
				dataID : sponsor.id,
				label : sponsor.name,
				icon : sponsor.logo_white_url
			};

			selectorContent.push(sponsorItem);
		}

		selectorContent.sort((a, b) => { return a.label > b.label } );
		const buttonLabel = (
			<div className='sponsor-selector'>
				<img src={window._fiSponsor.sponsors[0].logo_white_url} alt='fi logo' />
			</div>
			);
		return (<div className='sponsor-selector'>
					<MenuController items={selectorContent} button_label={buttonLabel} onClick={this.onClick} />
				</div>
		);
	}
}

export default FISelector;